import OptionHTML from "./Option";

const DeleteButtonText = () => {
  const span = document.createElement('span');
  span.classList.add('blind');
  span.textContent = '삭제';
  return span;
};

const DeleteButton = () => {
  const button = document.createElement('button');
  button.classList.add('search_del');
  button.setAttribute('type', 'button');
  button.append(DeleteButtonText());
  return button;
};

const Input = () => {
  const input = document.createElement('input');
  input.classList.add('search_input');
  input.setAttribute('type', 'text');
  input.setAttribute('title', '옵션 검색');
  input.setAttribute('placeholder', '검색할 옵션명을 입력하세요');
  return input;
};

const SearchInput = () => {
  const div = document.createElement('div');
  div.classList.add('search_wrap');
  div.append(Input(), DeleteButton());
  return div;
};

const SearchInputHTML = () => {
  return SearchInput().outerHTML;
}

export default SearchInputHTML;

export function updateBySeach(optionList, keyword) {
  const openDepth = document.querySelector('.dep-sel.open');
  if (!openDepth || !optionList) return;

  const getInnerHtml = () => {
    if (!keyword) {
      return optionList.map(
        option => OptionHTML(option, option.index, keyword)
      ).join('');
    }

    const lowerCased = keyword.toLowerCase();
    const searchResult = optionList.filter((option) => {
      const optionTitle =
        option.value || option.optionTitle.split("|").pop();
      return optionTitle.toLowerCase().includes(lowerCased);
    });

    if (searchResult.length === 0) {
      return '<li class="search_none">일치하는 상품이 없습니다.</li>';
    }
    return searchResult.map(
      option => OptionHTML(option, option.index, keyword)
    ).join('');
  };

  const optionListContainer = openDepth.children[1];
  optionListContainer.innerHTML = getInnerHtml();
}
